import React from 'react';
import SVGIcon from './SVGIcon';
import * as styles from './Tag.module.scss';

interface TagProps {
  icon: React.ReactNode;
  children: React.ReactNode;
}

const Tag = ({ icon, children }: TagProps) => (
  <div className={styles.wrapper}>
    {typeof icon === 'string' ? <SVGIcon size={12}>{icon}</SVGIcon> : icon}
    <div className={styles.content}>{children}</div>
  </div>
);

export default Tag;
